import { render, staticRenderFns } from "./LogoWithTradeMark.vue?vue&type=template&id=750bd218&scoped=true&"
import script from "./LogoWithTradeMark.vue?vue&type=script&lang=js&"
export * from "./LogoWithTradeMark.vue?vue&type=script&lang=js&"
import style0 from "./LogoWithTradeMark.vue?vue&type=style&index=0&id=750bd218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750bd218",
  null
  
)

export default component.exports